import type { ImpressionType } from '@/ImpressionType'

export const impressionDataPosteMortem: ImpressionType = {
  title: 'Poste mortem',
  impressionContent: `

<p>Que reste t'il de cette terrible histoire ? De nous ?</p><br/>

<p>Un deuil c'est la recomposition d'un lien.. et ta mort nous a rapproché.</p><br/>

<p>Ou plus exactement m'a rapproché de toi.</p><br/>

<p>Nous n'étions pas proches, jamais tu n'as pensé à moi comme personnage de ta vie.</p><br/>

<p>J'étais littéralement une annotation, un commentaire du texte que tu nous a laissé.</p><br/>

<p>Moins que ton frère, moins qu'un parent éloigné. Pas grand chose.</p><br/>

<p>Si tu n'as rien de moi, tu es sans doute bien plus que je ne le réalise.</p><br/><br/>

<p>Te rends-tu compte ? Même morte je trouve spontanément des traces de toi.</p><br/>

<p>Il suffit de me lire, et je suis sûr que tu l'aurais vu, si tu étais là.</p><br/><br/>

<p>Tu m'as aidé à structurer beaucoup de choses, mon humour, ma curiosité intellectuelle.</p><br/><br/>

<p>Je me souviens de ces moments d'insouciance dans notre jeunesse, de ces jeux d'enfants sur la plage. Notre complicité ? Non pas vraiment. Mais tu m'as ouvert une fenêtre sur ton monde, puis sur le monde. Et j'ai pu m'échapper.</p><br/><br/>

<p>A côté de toi, je n'étais rien, tu attirais la lumière, si en avance sur moi, si assuré de toi, tes qualités.</p><br/><br/>

<p>Mais les armures écrasent.</p><br/><br/>

<p>Toi et moi, nous fûmes en partie, en compétition. Te sentais tu menaçais plus tard par ma compréhension du monde ? Toi qui avais toujours été vu comme la meilleure ?</p><br/>

<p>Non, je pense que je n'existais pas tant que ça. Tes adieux me suffisent. Je n'étais pas plus qu'un étranger que tu n'aurais "pas reconnu".</p><br/><br/>

<p>Pourtant. C'est cet étranger qui t'a porté vers ton ultime demeure.</p><br/><br/>

<p>Qui était là pour voir jusqu'au bout, ton visage. Qui a essayé de te veiller, un peu, seul, pour partager les rares moments que nous avions ensemble... Toi sur ton dernier lit, moi dans ce moment de ma vie ou tout se désagrège.</p><br/>

<p>J'étais là, en mer, sans que tu le veuilles. Y avait tu pensais ? Je ne saurais jamais.</p><br/><br/>

<p>Aurais tu pensais que ton petit frère serait le dépositaire de tes cendres ? Que ces mots t'inscrive aussi quelque part ? Dans mon monde du moins.</p><br/><br/>

<p>Écrire c'est conserver une trace du passé, offrir a un de nos moments, une histoire, une transcendance, un refus de l'abîme.</p><br/>

<p>Écrire, c'est aussi un geste, je pense, d'amour. J'étais là, avec nos parents, pour exécuter tes dernières volonté, ton dernier voyage. En intrus. En parvenu.</p><br/><br/>

<p>Je suis sûre que toi, tu aurais vécu les choses comme moi. A notre père j'ai dit "15 ans avant j'aurai pu être à sa place sur un lit de mort".</p><br/>

<p>Est-ce une chose qui l'a fait réfléchir ? Peut être. La douleur nous rend tellement sourd... Mais pas aveugle.</p><br/><br/>

<p>Tu aurais fait la même chose pour moi.<br/><br/>

<p>Certes je n'aurai pas préparé ma mort aussi méticuleusement que toi ! Chapeau !</p><br/>

<p>Mais je pense que tu n'aurais pas été aussi jusqu' au boutiste que moi, pour te rendre hommage, pour prendre soin de toi.. pour me donner bonne conscience ? Qui sait.</p><br/>

<p>Je me souviens comment je veillais affectueusement sur toi, tes cendres, lors de ton dernier voyage.</p><br/>

<p>Je sais que comme moi, tu aurais essayé de comprendre autrement notre lien. Un deuil dévaste, et je pense que tout ça, comme moi, t'aurais fait repenser à nos moments de bonheur.</p><br/>

<p>Avoir eu cette fenêtre sur ton monde, de désespoir, d'angoisse, de tristesse, sans pouvoir y être acteur... Quel gâchis.</p><br/>

<p>Je me prends souvent à rêver de ce qui aurait pu être, à rêver d'être là pour t'aider a surmonter cette dépression.</p><br/>

<p>Bref. Ce ne sera jamais... Mais je me dis que tu es encore : quelque part.</p><br/>

<p>J'entends souvent tes musiques, au détour d'une rue, d'un moment de ma vie. Quand je l'entends, je pense à toi : Rihanna, Julien Doré en tête !</p><br/>

<p>Je t'écoute souvent, te regarde souvent. Je médite sur ton sort, ta vie, ta fin, notre lien..</p><br/><br/>

<p>
Je ne peux pas te dire que je t'aime.<br/>
J'ai énormément de tendresse pour toi.<br/>
J'aurai été un bien meilleur grand frère pour toi.<br/>
Avoue le... Je suis plus brillant que toi ^^ trop scolaire par rapport à moi !
</p><br/>

<p>Tu as eu tout ce que tu pouvais avoir d'honneur, d'attention, même de sex appeal ! Pas moi.</p><br/>

<p>Mais, j'ai fait mon chemin, avec l'humilité des personnes qui doivent se battre pour avoir accès à tout, et l'orgueil de ceux qui pensent qu'il vale mieux que le reste ! Et tu m'as aidé à "voir le monde", première étape pour se découvrir soit même.. et aimer.</p><br/>

<p>Tu m'as fait découvrir les rares références littéraires que j'ai. Au premier rang desquels "Les fleurs bleues" qui trônent sur ma table de nuit.</p><br/>

<p>Ton écriture, ton toi jeune, est à côté de moi. Je pense souvent à cette jeune fille qui avait le monde en face d'elle, prête à le conquérir. Quelle tristesse et quel gâchis...</p><br/>

<p>Mais dans mes mots, tu es bel et bien présente. Même si je ne le veux pas.</p><br/><br/>

<p>Plonger dans ta mort, littéralement, c'est faire émerger ton légue. C'est d'autant plus frappant quand je vois comment je l'écris.. bref. Ton frère écrit des choses moins déprimantes que les tiennes !</p><br/>

<p>
Bref.<br/>
Je suis convaincu que tu es là, quelque part.<br/>
J'en suis convaincu quand je vois comment le ciel t'a accompagné dans ton dernier voyage.<br/>
Combien pour ceux qui sont encore là, tu peux te manifester.<br/>
Je te cherche aussi, dans pas mal de signes.<br/>
Je te donne même encore une place dans la vie, dans notre monde des vivants, en accrochant un peu ta mémoire a mon existence..
</p><br/><br/>

<p>Comme un baluchon !</p><br/><br/>

<p>J'ai voulu récupérer ta bibliothèque, tes écrits, le plus possible, qu'une personne un jour me dise "c'est qui qui a écrit ces mots ?"... Joli prétexte pour te raconter pas vrai ?</p><br/>

<p>
Qu'aurais tu fais à ma place ? Je ne le saurais jamais.<br/>
Je peux juste te dire que moi, j'étais présent pour toi.<br/>
Je l'étais et le suis encore.<br/>
Bienvenue dans mon monde.<br/>
Même si irrémédiablement il a changé,<br/>
Le jour où tu es parti.
</p>

<br/><br/>
<p>Affectueusement.</p>

<br/>
<p>Ton frère.</p>

<br/>
<br/>
<p>PS : tu es une conne.
 `,
  illustrationCaption: 'Repos-sur-mer',
  illustrationCopyright: 'Source: openai',
  illustrationPath: '/img/impressions/poste-mortem-1.jpg',
  noteEntries: ['Une pierre de plus a ta sépulture ma soeur..']
}
